import React from 'react'
import { OrderManagement } from '../components/admin'

const AdminOrders: React.FC = () => {
  return <OrderManagement />
}

export default AdminOrders